<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>My Bills</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">My Bills</ion-title>
                </ion-toolbar>
            </ion-header>
            <div id="container">
                <DataTable :loading="loading" :metaKeySelection="false" class="p-datatable-sm" showGridlines :value="bills" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"  @page="onPage($event)" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column field="id" header="ID"></Column>
                    <Column field="bill_type" header="Bill Type"></Column>
                    <Column field="total_amount" header="Total Amount"></Column>
                    <Column field="date" header="Date">
                        <template #body="{data}">
                            {{new Date(data.date).toLocaleDateString()}}
                        </template>
                    </Column>
                    <Column field="status" header="Status"></Column>
                    <Column field="id" header="Action">
                        <template #body="{data}">
                            <ion-button size="small" @click="detailData=data">Details</ion-button>
                        </template>
                    </Column>
                </DataTable>
                <ion-modal :is-open="detailData!=null"  @didDismiss="()=>{this.detailData=null}">
                    <ion-page>
                        <ion-header>
                        <ion-toolbar mode="ios">
                            <ion-buttons slot="end">
                            <ion-button @click="detailData=null">Close</ion-button>
                            </ion-buttons>
                            <ion-title>Bill Details</ion-title>
                        </ion-toolbar>
                        </ion-header>
                        <ion-content v-if="detailData!=null" :fullscreen="true">
                            <ion-item>
                                <ion-label>ID</ion-label>
                                <ion-text>
                                    {{detailData.id}}
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Total Amount</ion-label>
                                <ion-text>
                                    {{detailData.total_amount}}
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Status</ion-label>
                                <ion-text>
                                    {{detailData.status}}
                                    <div v-for="(ibv,i) of detailData.inhouse_bill_verifications" :key="i">
                                        <strong>{{ibv.submit_to.name}}:</strong> {{ibv.status}}
                                        <small v-if="ibv.status!='pending'">
                                            ({{new Date(ibv.approved_or_declined_at).toLocaleDateString()}}) 
                                            <div v-if="ibv.status=='declined'">
                                            Msg: {{ibv.decline_reason}}
                                            </div>
                                        </small>
                                    </div>
                                </ion-text>
                            </ion-item>
                            <ion-item>
                                <ion-label>Date</ion-label>
                                <ion-text>
                                    {{new Date(detailData.date).toLocaleDateString()}}
                                </ion-text>
                            </ion-item>
                            <ion-item v-for="(expense,i) of detailData.inhouse_bill_expenses" :key="i">
                                <div>
                                <h2>
                                    {{expense.expense_head.name}}
                                </h2>
                                    <div v-for="(key,i) of Object.keys(JSON.parse(expense.data))" :key="i">
                                        <strong>{{key}}:</strong> {{JSON.parse(expense.data)[key]}}
                                    </div>
                                    <div>
                                        <strong>Amount:</strong> {{expense.amount}}
                                    </div>
                                    <div v-for="(img,i) of JSON.parse(expense.attachment)" :key="i">
                                        <ion-img :src="host+'inhouse_bill_attachments/'+img">
                                        </ion-img>
                                    </div>
                                </div>
                            </ion-item>
                            
                        </ion-content>
                    </ion-page>
                </ion-modal>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonText, IonItem, IonToolbar, IonButton, IonModal, IonLabel, IonImg, alertController } from '@ionic/vue';
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { host } from '../config';

export default defineComponent({
  name: 'My Device',
  data(){
      return {
          host,
          bills:[],
          detailData:null,
          loading:false,
          perPage:20,
          total:0,
      }
  },
  mounted(){
      this.loadData(0);
  },
  methods:{
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
      async loadData(page){
          const data={
              'page':page + 1,
              'username':window.localStorage.username,
              'password':window.localStorage.password,
          };
          this.loading=true;
        this.$http.post('myBills',data).then(response=>{
            // const rows=[];
            this.perPage=response.data.per_page;
            this.total=response.data.total;
            this.bills=response.data.data;
            this.loading=false;
        });

      },
      onPage(event){
          this.loadData(event.page);
      },
      transfer(){
          if(this.selectedDevices.length==0){
            this.presentAlert("No device seleted!");
            return;
          }
          const serials=[];
          for(const d of this.selectedDevices){
              serials.push(d.serial);
          }
          this.$router.push('/gps-device-transfer/'+JSON.stringify(serials));
      },
       async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    DataTable,
    Column,
    IonText,
    IonItem,
    IonModal,
    IonLabel,
    IonImg
  }
});
</script>

<style>
/* .dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
} */
</style>